import { Tower } from './Tower';
import { Monster } from '../monsters/Monster';

export class RapidFireTower extends Tower {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    // damage: 8, attackSpeed: 3.0, range: 120 - low damage, high speed
    super(scene, x, y, 8, 3.0, 120);
    
    // Override visual representation
    this.removeAll();
    this.createRapidFireVisuals();
  }

  protected override createVisuals(): void {
    // Create rapid fire tower base
    const base = this.scene.add.circle(0, 0, 18, 0x330033);
    this.add(base);
    
    // Create twin barrels for rapid fire effect
    const barrel1 = this.scene.add.rectangle(-3, -15, 6, 20, 0x00ffff);
    const barrel2 = this.scene.add.rectangle(3, -15, 6, 20, 0x00ffff);
    this.add(barrel1);
    this.add(barrel2);
    
    // Add muzzle flashes
    const muzzle1 = this.scene.add.circle(-3, -25, 2, 0xffff00);
    const muzzle2 = this.scene.add.circle(3, -25, 2, 0xffff00);
    this.add(muzzle1);
    this.add(muzzle2);
  }

  private createRapidFireVisuals(): void {
    this.createVisuals();
  }

  protected override fireProjectile(target: Monster, damage: number, isCrit: boolean): void {
    // Create small, fast bullet
    const bullet = this.scene.add.circle(this.x, this.y, isCrit ? 4 : 2, isCrit ? 0xff0000 : 0x00ffff);
    
    // Animate bullet to target quickly
    this.scene.tweens.add({
      targets: bullet,
      x: target.x,
      y: target.y,
      duration: 100, // Very fast bullet
      ease: 'Power2',
      onComplete: () => {
        // Apply damage
        if (this.pierceCount > 0) {
          this.applyPiercingDamage(target, damage, this.pierceCount);
        } else {
          target.takeDamage(damage);
        }
        
        // Show crit effect
        if (isCrit) {
          this.showCritEffect(target.x, target.y);
        }
        
        bullet.destroy();
      }
    });
  }
} 